var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChemicalDosing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.00018H28V23.0002H2V5.00018Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.00018H28V23.0002H2V5.00018Z",
    fill: "#0679CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000183105H30V5.00018H0V0.000183105Z",
    fill: "#002D62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.50018H6V9.00018H8V10.0002H6V12.2502H8V13.2502H6V16.5002H8V17.5002H6V18.5002H5V8.50018Z",
    fill: "#002D62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.0002V8.00018H24V14.0002H18V20.5002H11.5V27.0002H30Z",
    fill: "#024D82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 7.50018H23.5V13.5002H17.5V20.0002H11V27.5002H30.5V7.50018ZM29.5 8.50018V26.5002H12V21.0002H18.5V14.5002H24.5V8.50018H29.5Z",
    fill: "#012946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicalDosing);
export default __webpack_public_path__ + "static/media/chemical_Dosing.1214cf8bd2453afbcf26dbb397bc269a.svg";
export { ForwardRef as ReactComponent };